import React from 'react';
import config from '../../config';
import { Route } from 'react-router-dom';
import StyleGuidePage from './StyleGuidePage';

const routes = () => {
  if (config.stage !== 'test') return [];
  return [
    <Route key="/style" exact path="/style" component={StyleGuidePage}/>,
  ];
};

export default routes;
